<template lang="pug">
    .stripe-api-keys(v-if="sk >= 0 && whk >= 0")
        h4
            i.el-icon-fa-credit-card.fas
            | {{ $t('Stripe') }}

        //- :prop="`administrators.${index}.cms.apiKeys.${k}.public`"

        el-form-item(:label="$t('Public Key')")
            el-input(type="input" v-model="public" maxlength="255" show-word-limit)

        el-form-item(:label="$t('Secret Key')")
            el-input(type="input" v-model="private" maxlength="255" show-word-limit)

        el-form-item(:label="$t('Webhook Secret')")
            el-input(type="input" v-model="webhookSecret" maxlength="255" show-word-limit)
</template>

<i18n>
{
    "de": {
        "Stripe": "Stripe",
        "Public Key": "Veröffentlichbarer Schlüssel",
        "Secret Key": "Geheimschlüssel",
        "Webhook Secret": "Webhook Secret"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { useSettingsStore, useCmsWizardStore } from '@/stores'

export default {
    name: 'StripeKey',
    props: {
        cms: {
            type: Object,
            required: true,
        },
        storeModule: {
            type: String,
            default: 'settings/form',
        },
    },
    data() {
        return {
            key: 'stripe',
            whKey: 'stripe-webhook',
        }
    },
    computed: {
        isWizardMode() {
            return this.storeModule === 'cmsWizard';
        },
        sk() {
            // get the index of cms related api key with identifier 'stripe'
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.key)
        },
        whk() {
            // get the index of cms related api key with identifier 'stripe-webhook'
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.whKey)
        },
        public: {
            get() {
                return _.get(this.cms, `apiKeys.${this.sk}.public`, '')
            },
            set(value) {
                const data = {
                    index: this.sk,
                    field: 'public',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
        private: {
            get() {
                return _.get(this.cms, `apiKeys.${this.sk}.private`, '')
            },
            set(value) {
                const data = {
                    index: this.sk,
                    field: 'private',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
        webhookSecret: {
            get() {
                return _.get(this.cms, `apiKeys.${this.whk}.private`, '')
            },
            set(value) {
                const data = {
                    index: this.whk,
                    field: 'private',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
    },
    mounted() {
        if (this.isWizardMode) {
            if (this.sk < 0) useCmsWizardStore().addCmsApiKey(this.key);
            if (this.whk < 0) useCmsWizardStore().addCmsApiKey(this.whKey);
        } else {
            if (this.sk < 0) useSettingsStore().addFormCmsApiKey(this.key);
            if (this.whk < 0) useSettingsStore().addFormCmsApiKey(this.whKey);
        }
    }
}
</script>

<style lang="sass" scoped>
    .stripe-api-keys
        padding-left: 12px
        position: relative
        &:before
            content: ''
            position: absolute
            left: 0
            top: 0
            bottom: 0
            width: 4px
            background: rgba($color-grey-text, .2)
            border-radius: 6px
        h4
            color: $color-grey-text
</style>
